import React from 'react';
import StyledInput from 'src/components/BeaconV2Components/common/StyledInput';
import useRemainingCharacters from 'src/components/BeaconV2Components/hooks/useRemainingCharacters';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

export type SlLimitedInputProps = React.ComponentProps<typeof StyledInput> & {
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  /**
   * Maximum number of characters allowed in the input
   */
  characterLimit: number;
};

/**
 * Input component that displays the number of characters remaining out of a specified limit.
 *
 * Note that this must be used as a controlled component with the `value` and `onChange` props
 * in order to work properly.
 */
export const SlLimitedInput = React.forwardRef<HTMLInputElement, SlLimitedInputProps>(function SlLimitedInput(
  { characterLimit, onChange, ...rest },
  ref
) {
  const remainingChars = useRemainingCharacters(rest.value as string, characterLimit);

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    if (event.target.value.length <= characterLimit) {
      // eslint-disable-next-line no-unused-expressions
      onChange?.(event);
    } else {
      event.preventDefault();
    }
  };

  return (
    <Flex flexDirection="column" gap="sm">
      <StyledInput
        sx={{
          height: '32px'
        }}
        ref={ref}
        onChange={handleChange}
        {...rest}
      />
      <Text
        sx={{
          fontSize: '10px',
          fontWeight: 500,
          alignSelf: 'flex-end'
        }}
      >{`${remainingChars} characters remaining`}</Text>
    </Flex>
  );
});
